import Config from "@skin_config";

import { broadcast, broadcastChannels } from "@common/helpers/broadcast";
import { swarmRequest } from "@common/helpers/util/requestMiddleware";
import { TitoCashoutAcceptBet } from "@app/dev/actions/terminal";
import { openDeferModal } from "@tickets/helpers/openDeferPopup";
import { GetUserId } from "@app/dev/helpers/selectors";
import { store } from "@app/dev/index/terminalApp";
import { getTicketData } from "@tickets/services";
import { POPUPS } from "@common/constants/popups";
import { payUserBet, verifyUser } from "@app/dev/helpers/verification";
import { checkPayingUser, getTicketBarcode } from "@tickets/components/cardView/helper";
import ToastWrapper from "@common/helpers/toastWrapper";

export const makeEarlyCashout = (barcode, amount) => {
	store.dispatch(
		TitoCashoutAcceptBet({
			barcode,
			amount,
		})
	);
};

const getLastAmount = async (ticket, cashoutAmount) => {
	const state = store.getState();
	const userId = GetUserId(state);

	if (userId) return cashoutAmount;

	const data = await getTicketData(ticket.dataFromSwarm.barcode);
	return data?.dataFromSwarm?.cashout_amount;
};

const confirmCashoutAmount = async (ticket, cashoutAmount) => {
	const lastCashoutAmount = await getLastAmount(ticket, cashoutAmount);

	if (lastCashoutAmount === cashoutAmount) return lastCashoutAmount;

	if (!lastCashoutAmount) {
		ToastWrapper("error", "Cashout is no longer available");
		return null;
	}

	const isConfirmed = await openDeferModal(POPUPS.CASHOUT_POPUP, { cashoutAmount: lastCashoutAmount });

	return isConfirmed ? confirmCashoutAmount(ticket, lastCashoutAmount) : null;
};

export const userCashout = async ticket => {
	if (!ticket.dataFromSwarm) return;

	const data = await swarmRequest(
		{
			bet_id: ticket.dataFromSwarm.id,
			price: ticket.dataFromSwarm.cash_out,
		},
		"cashout"
	);
	return {
		success: data.result === "Ok",
		newPrice: data.details?.new_price,
	};
};

export const earlyCashout = (ticket, cashoutAmount) => {
	const state = store.getState();
	const userId = GetUserId(state);

	if (userId) return userCashout(ticket);

	return new Promise(async resolve => {
		const onResponse = e => {
			broadcast.removeEventListener(broadcastChannels.EarlyCashoutResult, onResponse, { once: true });

			const shouldSendToBIS = e.detail.success && verificationData?.success;

			shouldSendToBIS &&
				payUserBet(verificationData.data, {
					...ticket.dataFromSwarm,
					amount: confirmedCashoutAmount,
				});

			setTimeout(() => {
				resolve(e.detail);
			}, 2000) // adding timeout for syncing with c# cooldown process -_-
		};

		const needToPassVerification =
			Config.verification?.enabled &&
			Config.verification?.payerValidation &&
			ticket.dataFromSwarm?.member_id;

		const verificationData = needToPassVerification ? await verifyUser() : null;

		if (needToPassVerification) {
			if (!verificationData?.success) {
				resolve(null);
				return;
			}

			const isValidPayer = checkPayingUser([ticket], verificationData);

			if (!isValidPayer) {
				resolve(null);
				return;
			}
		}

		const confirmedCashoutAmount = await confirmCashoutAmount(ticket, cashoutAmount);

		broadcast.addEventListener(broadcastChannels.EarlyCashoutResult, onResponse);

		if (confirmedCashoutAmount) makeEarlyCashout(getTicketBarcode(ticket), confirmedCashoutAmount);
		else return null;
	});
};
